import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config";
import "./AdminShared.css";

const AdminProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  // 🔐 SECURITY CHECK
  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) return navigate("/admin");
    fetchProducts();
  }, [navigate]);

  // 🔥 FETCH ALL PRODUCTS (NO AUTH HEADER—MATCH COURSE)
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/products`);
      if (!res.ok) throw new Error("Failed to fetch products");
      const data = await res.json();
      setProducts(Array.isArray(data) ? data.reverse() : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [location.search]);

  const handleDelete = async (id) => {
    if (!window.confirm("Purge this commercial asset?")) return;
    try {
      await fetch(`${API_BASE_URL}/api/products/${id}`, { method: "DELETE" });
      fetchProducts();
    } catch (error) { console.error(error); }
  };

  const filteredProducts = products.filter((p) =>
    (p?.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="admin-list-container"><p style={{ padding: '100px', textAlign: 'center' }}>⏳ Synchronizing Product Inventory...</p></div>;

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Asset Inventory</h1>
        </div>
        <button className="module-badge" style={{ cursor: 'pointer', background: '#ef4444', border: 'none' }} onClick={() => navigate("/admin/add-product")}>
          + Register Asset
        </button>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#ef4444' }}></div>
            Operator: Supply Chain Node
          </div>
          <div className="admin-controls">
            <div className="admin-search-wrapper">
              <span className="search-icon-fixed">🔍</span>
              <input
                type="text"
                placeholder="Search inventory matrix..."
                className="admin-search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-status-badge" style={{ background: '#fef2f2', color: '#991b1b', fontSize: '0.75rem', fontWeight: 800 }}>
            {products.length} REGISTERED ASSETS
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Asset Designation</th>
                <th>Stock Category</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
                    No assets detected in the primary inventory buffer.
                  </td>
                </tr>
              ) : (
                filteredProducts.map((item, idx) => (
                  <tr key={item._id}>
                    <td style={{ width: '80px' }}>{idx + 1}</td>
                    <td>
                      <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{item.name}</div>
                      <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>ASSET-UID: {item._id.slice(-6).toUpperCase()}</div>
                    </td>
                    <td>
                      <span className="status-tag status-approved" style={{ background: '#fef2f2', color: '#ef4444', border: '1px solid #fee2e2' }}>
                        STOCKED
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button className="action-btn-elite btn-update" onClick={() => navigate(`/admin/editproduct/${item._id}`)}><span>✏️</span> Update</button>
                        <button className="action-btn-elite btn-delete" onClick={() => handleDelete(item._id)}><span>🗑️</span></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminProduct;
